import {II18nMap} from "./en";

export const es419: II18nMap = {
	"page_progress_title": "Mi Progreso",
	"page_progress_finished_courses": "Cursos Completados",
	"page_progress_finished_courses_subtitle": "Mira qué cursos has completado hasta ahora",
	"page_progress_active_courses": "Cursos Activos",
	"page_progress_active_courses_subtitle": "Regresa a los cursos en los que participas",
	"page_progress_recent_activity": "Actividad Reciente",
	"page_progress_recent_activity_subtitle": "Mira lo que has completado hasta ahora",
	"page_progress_no_courses": "No hay cursos completados",
	"page_progress_finished_course_unavailable": "No disponible",
	"page_progress_resume_button": "Reanudar",
	"page_progress_no_recent_activity": "No hay actividad reciente",
	"page_progress_no_modules": "No se encontraron módulos",

	"page_settings_title": "Preferencias de Entrenamiento",
	"page_settings_language": "Idioma Preferido",
	"page_settings_english": "Inglés",
	"page_settings_spanish": "Español",
	"page_settings_manage_account": "Administrar detalles de la cuenta",
	"page_settings_save_button": "Guardar",
	"page_settings_cancel_button": "Descartar",

	"page_feed_title": "Mi Feed",

	"page_streak": "Completa todas las tareas pendientes de hoy para aumentar tu racha diaria",

	"search_courses": "Buscar cursos",

	"search_placeholder": "Título del Curso, Título de la Lección, Autor, Descripción de la Lección",

	"nav_feed": "Mi Feed",
	"nav_library": "Biblioteca de Cursos",
	"nav_progress": "Mi Progreso",
	"nav_notes": "Mis Notas",
	"nav_manager": "Gestor de Contenido",

	"nav_mobile_feed": "Feed",
	"nav_mobile_library": "Biblioteca",
	"nav_mobile_progress": "Progreso",
	"nav_mobile_notes": "Notas",

	"menu_profile_settings": "Preferencias de Entrenamiento",
	"menu_profile_account": "Mi Cuenta",
	"menu_profile_support": "Soporte",
	"menu_profile_logout": "Cerrar sesión",

	"common_notes_delete": "Eliminar",
	"common_notes_cancel": "Cancelar",
	"common_notes_edit": "Editar",
	"common_notes_saving": "Guardando…",
	"notes_delete_confirm_title": "¿Estás seguro?",
	"notes_delete_confirm_content": "Una vez que elimines este elemento, no podrás recuperarlo.",
	"notes_delete_success": "Nota eliminada",
	"notes_delete_error": "No se pudo eliminar la nota. Inténtalo de nuevo.",
	"common_notes_deleted_lesson": "Lección Eliminada",

	"notifications_settings_updated": "Tus datos han sido actualizados",
	"notifications_wrong_title": "Algo salió mal",
	"notifications_wrong_body": "Por favor, inténtalo de nuevo",
	"notifications_reschedule_success": "Las lecciones se reprogramaron correctamente.",
	"notifications_reschedule_error": "No se pudieron reprogramar las lecciones. Por favor, inténtelo de nuevo.",
	"page_notes_all": "Todas",
	"page_notes_title": "Biblioteca de Notas",
	"common_notes_in": "en",
	"common_notes_search": "Buscar",
	"menu_profile_language_settings": "Preferencias de Idioma",
	"menu_profile_profile": "Perfil",
	"menu_profile_view_profile": "Ver perfil",
	"menu_profile_report_issue": "Reportar problema",
	"menu_profile_suggest_feature": "Sugerir una idea",
	"team_progress_widget_completedCourses": "Cursos Completados",
	"team_progress_widget_completedLessons": "Lecciones Completadas",
	"team_progress_widget_timeInTraining": "Tiempo viendo lecciones",
	"team_progress_widget_activeUsers": "Usuarios con completación de lecciones",
	"team_progress_widget_inactiveUsers": "Usuarios sin completación de lecciones",
	"team_progress_widget_usersWithOverdueLessons": "Usuarios con Lecciones Vencidas",
	"team_progress_under_construction": "En Construcción",
	"team_progress_filter_last_week": "Esta semana",
	"team_progress_filter_last_month": "Este mes",
	"team_progress_filter_last_year": "Este año",
	"team_progress_filter_custom_date_range": "Fecha Personalizada",
	"team_progress_filter_archived_users": "Mostrar inactivos",
	"team_progress_calendar_add": "Agregar",
	"team_progress_calendar_cancel": "Cancelar",
	"team_progress_title": "Progreso del Equipo",
	"team_progress_subtitle": "Monitorear el compromiso de aprendizaje y el progreso de los empleados",

	// User enrollment types
	"user_enrollment_type_learner": "Autoasignado",
	"user_enrollment_type_strapi-admin": "Asignado por administrador",
	"user_enrollment_type_auto-assign-schedule": "Asignado automáticamente",
	"user_enrollment_type_prioritize-schedule": "Asignado por administrador",
	"user_enrollment_type_due-date-schedule": "Asignado por administrador",
	"user_enrollment_type_admin-assigned": "Asignado por administrador",

	// Course categories
	"course_category_Job Training": "Capacitación laboral",
	"course_category_Personal Development": "Desarrollo Personal",
	"course_category_Professional Development": "Desarrollo Profesional",
	"course_category_Safety": "Seguridad",
	"course_category_others": "Otros",

	"completed_lessons_column_firstname": "Nombre",
	"completed_lessons_column_lastname": "Apellido",
	"completed_lessons_column_lesson": "Lección",
	"completed_lessons_column_duration": "Duración",
	"completed_lessons_column_supervisor": "Supervisor",
	"completed_lessons_column_division": "División",
	"completed_lessons_column_job_category": "Categoría de Trabajo",
	"completed_lessons_column_completed_on": "Completado en",
	"completed_lessons_column_enrollment_type": "Tipo de Inscripción",
	"completed_lessons_column_course": "Curso",
	"completed_lessons_column_email": "Email",
	"completed_lessons_column_phone": "Teléfono",
	"completed_lessons_column_job_title": "Título del Trabajo",
	"completed_lessons_column_status": "Estado",
	"completed_lessons_column_streak": "Racha",
	"completed_lessons_column_employee_code": "Código de Empleado",
	"completed_lessons_viewing_stats_past_week": "VIENDO ESTADÍSTICAS DE LA SEMANA PASADA",
	"completed_lessons_viewing_stats_past_month": "VIENDO ESTADÍSTICAS DEL MES PASADO",
	"completed_lessons_viewing_stats_past_year": "VIENDO ESTADÍSTICAS DEL AÑO PASADO",
	"completed_lessons_viewing_stats_custom_range": "VIENDO ESTADÍSTICAS DE ",
	"completed_lessons_viewing_stats_all_time": "VIENDO ESTADÍSTICAS DE TODO EL TIEMPO",
	"data_grid_export_tooltip": "Viene Pronto",
	"common_content_type": "Tipo de Contenido",
	"common_last_active": "Última vez Activo",
	"common_employee_code": "Código de empleado",
	"common_first_name": "Nombre",
	"common_last_name": "Apellido",
	"common_email": "Correo electrónico",
	"common_job_category": "Categoría de trabajo",
	"common_job_title": "Título del trabajo",
	"common_hire_date": "Fecha de contratación",
	"common_title_start_date": "Inicio en el puesto",
	"common_enroll": "Inscribir",
	"common_due_date": "Fecha de vencimiento",
	"common_assigned_on": "Asignado el",
	"common_enrollment_type": "Tipo de inscripción",
	"common_course_completion": "Avance del curso",
	"common_division": "División",
	"common_supervisor": "Supervisor",
	"common_lessons": "Lecciones",
	"time_in_training": "Tiempo viendo lecciones",
	"completed_lessons": "Lecciones Completadas",
	"no_courses_found": "No se encontraron cursos",
	"common_export": "Exportar",
	"team_progress_one_report_a_time_msg": "Solo puedes descargar un informe a la vez.",
	"team_progress_generating_your_report_msg": "Generando su reporte… No cierre ni actualice esta ventana.",
	"team_progress_download_report_has_started": "Su descarga ha iniciado.",
	"team_progress_download_export_failed": "La exportación falló. Inténtalo de nuevo.",
	"common_overdue_lessons": "Lecciones Vencidas",
	"common_reschedule_overdue": "Reprogramar Vencido",
	"common_reschedule_overdue_tooltip_msg": "Reprogramar lecciones vencidas para usuarios seleccionados",
	"streak_day": "día de racha",
	"streak_days": "días de racha",
	"streak_day_message": "Completa una lección para aumentar tu racha.",
	"streak_lesson_completed": "¡Lección de hoy completada! Regresa mañana para continuar tu racha.",
	"streak_day_off": "Tienes el día libre. Tu racha está segura y avanza con buen ritmo.",
	"common_confirm": "Confirmar",
	"common_apply": "Aplicar",
	"bulk_reschedule_modal_title": "Reprogramar lecciones vencidas",
	"bulk_reschedule_modal_body_copy": "Esto reprogramará las lecciones de todos los usuarios seleccionados que tengan asignaciones vencidas.",
	"bulk_reschedule_progress_msg": "Reprogramando lecciones vencidas… No cierre ni actualice esta ventana.",
	"bulk_reschedule_error_msg": "No se pudieron reprogramar las lecciones. Por favor, inténtelo de nuevo.",
	"bulk_reschedule_success_msg": "Lecciones vencidas reprogramadas exitosamente para los usuarios seleccionados",

	"bulk_enrollment_modal_title_other": "Inscribir usuarios en el curso",
	"bulk_enrollment_modal_title_one": "Inscribir usuario en el curso",
	"bulk_enrollment_modal_body_copy_other": "Inscriba a los alumnos seleccionados en este curso.",
	"bulk_enrollment_modal_body_copy_one": "Inscriba a los alumnos seleccionados en este curso.",
	"bulk_enrollment_due_date_section_title": "Establecer una fecha de vencimiento (opcional)",
	"bulk_enrollment_due_date_section_helper": "Deje en blanco si no hay fecha de vencimiento.",
	"bulk_enrollment_prioritize_option": "Priorizar en el feed de capacitación",
	"bulk_enrollment_due_date_option": "Fecha de vencimiento",
	"bulk_enrollment_due_date_label": "Fecha de vencimiento",
	"bulk_enrollment_progress_msg": "Inscribiendo usuarios… No cierre ni actualice esta ventana.",
	"bulk_enrollment_error_msg": "No se pudieron inscribir los usuarios. Por favor, inténtelo de nuevo.",
	"bulk_enrollment_success": "Se inscribieron {{count}} usuario(s)",
	"bulk_enrollment_partial_success": "Se inscribieron {{enrolled}} usuario(s); {{failed}} fallaron",
	"bulk_enrollment_error": "No se pudieron inscribir los usuarios: {{message}}",
	"manage_due_dates_toolbar": "ADMINISTRAR FECHAS DE VENCIMIENTO",
	"manage_due_dates_modal_title": "Administrar fechas de vencimiento",
	"manage_due_dates_modal_subtitle": "Establecer o borrar fechas de vencimiento",
	"manage_due_dates_set_option_title": "Establecer fechas de vencimiento",
	"manage_due_dates_set_option_description": "Establecer o actualizar fechas de vencimiento para todos los registros seleccionados.",
	"manage_due_dates_clear_option_title": "Borrar todas las fechas de vencimiento",
	"manage_due_dates_clear_option_description": "Borrar las fechas de vencimiento de todos los registros seleccionados.",
	"manage_due_dates_clear_warning": "Esta acción no se puede deshacer.",
	"manage_due_dates_applying": "Aplicando...",
	"manage_due_dates_success": "Fechas de vencimiento actualizadas para {{count}} alumno(s)",
	"manage_due_dates_success_courses": "Fechas de vencimiento actualizadas para {{count}} curso(s)",
	"manage_due_dates_no_changes": "No se necesitaron cambios.",
	"manage_due_dates_partial_errors": "Se actualizaron {{updated}} alumno(s), {{failed}} fallaron",
	"manage_due_dates_error": "No se pudieron administrar las fechas de vencimiento: {{message}}",
	"bulk_action_errors_no_detail": "No se devolvieron detalles de error por usuario.",
	"notifications_enrollment_success": "Usuarios inscritos exitosamente.",
	"notifications_enrollment_error": "No se pudieron inscribir los usuarios. Por favor, inténtelo de nuevo.",
	"streak_drawer_text_content_tier2.1": "Empezaste una racha.",
	"streak_drawer_text_content_tier2.2": "Deja que la disciplina crezca exponencialmente.",
	"streak_drawer_text_content_tier3.1": "Racha de {{x}} días.",
	"streak_drawer_text_content_tier3.2": "Los hábitos son",
	"streak_drawer_text_content_tier3.3": "el motor silencioso del éxito.",
	"streak_drawer_text_content_tier4.1": "Racha de {{x}} días.",
	"streak_drawer_text_content_tier4.2": "Sin atajos ni excusas",
	"streak_drawer_text_content_tier4.3": "- solo progreso.",
	"common_congrats": "Felicitaciones",
	"common_continue": "Continuar",
	"completion_celebration_congratulations": "Felicitaciones!",
	"completion_celebration_you_completed": "Completaste",
	"completion_celebration_you_did_it": "Lo hiciste!",
	"settings_import_libraries": "Importar Librerías",
	"training_feed_watch_lesson": "Ver lección",
	"training_feed_tap_to_load": "Tocar para cargar",
	"training_feed_nothing_scheduled": "No hay entrenamiento programado para hoy.",
	"training_feed_all_completed_today": "Buen trabajo... ¡Has terminado por hoy!",
	"training_no_courses_enrolled": "Aún no estás inscrito en ningún curso.",
	"training_feed_overdue": "ATRASADO",
	"training_feed_upcoming": "PRÓXIMO",
	"training_feed_due_today": "VENCE HOY",
	"month_jan": "Ene",
	"month_feb": "Feb",
	"month_mar": "Mar",
	"month_apr": "Abr",
	"month_may": "May",
	"month_jun": "Jun",
	"month_jul": "Jul",
	"month_aug": "Ago",
	"month_sep": "Sep",
	"month_oct": "Oct",
	"month_nov": "Nov",
	"month_dec": "Dic",
	"mark_as_completed": "Marcar como completado",
	"module_tab_overview": "RESUMEN",
	"module_tab_comments": "COMENTARIOS",
	"module_tab_notes": "NOTAS",
	"please_scroll_to_continue": "Por favor, desplázate para continuar",
	"view_more": "Ver más",
	"view_less": "Ver menos",
	"quiz.submit_answers": "Enviar respuestas",
	"quiz.next_question": "Siguiente pregunta",
	"quiz.previous_question": "Pregunta anterior",
	"quiz.back": "Volver",
	"quiz.question_text": "Pregunta",
	"quiz.of_text": "de",
	"quiz.one_answer": "1 respuesta",
	"quiz.multiple_answers": "respuestas",
	"quiz.drag_to_order": "Arrastra las filas al orden correcto",
	"quiz.retake": "Volver a intentar",
	"quiz.pass_by_scoring": "Aprueba con una puntuación del 100%",
	"notes.most_recent": "Más recientes",
	"notes.oldest_first": "Más antiguos primero",
	"notes.input_placeholder": "Escribe tu nota privada",
	"comments.load_more": "Cargar más",
	"comments.input_placeholder": "Deja un comentario",
	"comments.reply_to_user": "Responder a {userName}",
	"comments.replies": "respuestas",
	"comments.today": "Hoy",
	"comments.yesterday": "Ayer",
	"comments.days_ago": "hace {count} días",
	"notifications_title": "Notificaciones",
	"notifications_mark_all_read": "Marcar todo como leído",
	"notifications_clear_all": "Limpiar todas las notificaciones",
	"notifications_all_up_to_date": "¡Estás al día con todo!",
	"notifications_marked_all_read": "Todas las notificaciones marcadas como leídas",
	"notifications_close_drawer": "Cerrar panel de notificaciones",
	"view_all": "Ver todo",
	"confirm_bulk_enrollment_title": "Confirmar inscripción masiva",
	"course_library_enroll_button": "INSCRIBIRSE",
	"course_library_overview_tab": "Descripción General",
	"course_library_lessons_tab": "Lecciones",
	"course_library_breadcrumb_courses": "Cursos",
	"course_overview_title": "Descripción del curso",
	"course_overview_number_of_lessons": "Número de lecciones:",
	"course_lessons_table_title": "Título",
	"course_lessons_table_subtitle": "Subtítulo",
	"course_lessons_table_type": "Tipo",
	"course_lessons_table_duration": "Duración",
	"course_lessons_title": "Lecciones",
	"course_lessons_table_total_rows": "Filas totales:",
	"common_unsaved_changes_title": "Los cambios no guardados se perderán",
	"common_unsaved_changes_message": "Perderás el trabajo no guardado si sales ahora. ¿Deseas continuar?",
	"common_exit": "Salir",
	"common_keep_editing": "Seguir editando",
	"bulk_playlist_enrollment_modal_title": "Inscribir usuarios en el Playlist",
	"bulk_playlist_enrollment_modal_content_1": "Al inscribir a un usuario en una lista de reproducción, se agregará la capacitación a la parte superior del feed de capacitación de su empleado.",
	"bulk_playlist_enrollment_modal_content_2": "Importante: tenga en cuenta que priorizar los cursos puede hacer que otros elementos bajen en la lista y afectar las fechas de vencimiento de otros cursos.",
	"bulk_playlist_enrollment_modal_content_3": "{{users}} usuarios seleccionados",
	"bulk_playlist_enrollment_modal_body_copy": "Esto inscribirá a los usuarios seleccionados en el playlist y en todos sus cursos. Elija cómo desea programar este playlist en su feed de capacitación.",
	"bulk_playlist_enrollment_success": "Usuarios inscritos en el playlist exitosamente",
	"bulk_playlist_enrollment_error": "Error al inscribir usuarios en el playlist",
	"common_enrolling": "Inscribiendo...",
	"bulk_enrollment_confirm_title": "Confirmar Inscripción Masiva",
	"admin_users_list_subtitle": "Ver y gestionar el progreso del usuario",
	"playlist_award_certification_label": "Otorgar una certificación cuando los alumnos completen esta lista de reproducción",
	"playlist_select_certificate_label": "Seleccionar Certificado",
	"common_unsaved_data_title": "Los datos no guardados se perderán",
	"create_playlist": "Crear lista de reproducción",
	"playlist_save_success": "Información guardada exitosamente",
	"playlist_save_error": "No se pudo guardar la información. Por favor, inténtelo de nuevo.",
	"playlist_max_courses": "Solo puede seleccionar hasta 25 cursos",
	"playlist_title_required": "El título de la lista es obligatorio",
	"playlist_created": "Lista creada correctamente",
	"playlist_updated": "Lista actualizada correctamente",
	"playlist_deleted": "Lista eliminada correctamente",
	"playlist_delete_error": "Error al eliminar la lista",
	"playlists": "Listas",
	"create": "Crear",
	"playlist_title": "Título",
	"playlist_courses": "Cursos",
	"playlist_content_preview": "Vista previa del contenido",
	"playlist_select_courses_hint": "Seleccione cursos para crear su lista",
	"remove_course": "Quitar curso",
	"delete_playlist_title": "Eliminar lista",
	"delete_playlist_message": "Esta lista se eliminará permanentemente. Los usuarios ya no verán estos cursos en su feed de capacitación, pero se guardará todo su progreso.",
	"common_name": "Nombre",
	"common_description": "Descripción",
	"common_Required": "Campo obligatorio",
	"certification_manage": "Gestionar la certificación",
	"certification_employees_awarded": "Empleados premiados",
	"certification_recently_added": "Agregado recientemente",
	"certification_add": "Agregar certificación",
	"certification_name": "Nombre de la certificación",
	"certification_code": "Código de certificación",
	"certification_granting_organization_name": "Nombre de la organización otorgante",
	"certification_expiration": "Vencimiento de la certificación",
	"certification_enter_number": "Ingrese el número",
	"certification_select_expirationUnit": "Seleccionar unidad de vencimiento",
	"certification_logo": "Logotipo de la certificación",
	"invalid_file_type": "Formato de archivo inválido. Inténtalo de nuevo.",
	"file_too_large": "Elija un archivo menor a {{number}} MB.",
	"certification_empty_logo": "Cargar Logo de la Certificación",
	"course_draft_not_enrollment_description": "Por favor, publique el curso para habilitar las inscripciones de usuarios.",
	"prioritized_enrollment_tooltip_copy": "La inscripción prioritaria comenzará el próximo día disponible para los usuarios.",
	"common_paused": "Pausado",
	"streak_unpause": "Reanudar Racha",
	"streak_pause": "Pausar Racha",
	"streak_paused": "Racha Pausada",
	"streak_paused_message": "Tu racha está pausada, pero tus fechas de vencimiento continuarán según lo programado.",
	"streak_unpaused_message": "Racha pausada removida. ",
	"streak_unpause_question": "Completaste una lección, pero tu racha está pausada. ¿Quieres reactivarla?",
	"page_home": "Inicio",
	// Scheduled Reports - Overview Card Tooltips
	"scheduled_reports_tooltip_total_watch_time": "Tiempo total dedicado a ver lecciones durante este período de informe, calculado sumando la duración del video de todas las lecciones completadas.",
	"scheduled_reports_tooltip_users_with_completed_lessons": "Porcentaje de usuarios que completaron al menos una lección durante este período de informe.",
	"scheduled_reports_tooltip_average_watch_time": "Tiempo promedio dedicado a ver lecciones por usuario, calculado dividiendo el tiempo total de visualización por el número total de usuarios.",
	"scheduled_reports_tooltip_completed_lessons": "Número total de lecciones completadas por todos los usuarios durante este período de informe.",
	"scheduled_reports_tooltip_completed_courses": "Número total de cursos completados por todos los usuarios durante este período de informe.",
	"scheduled_reports_tooltip_average_streak": "Racha diaria promedio en todos los usuarios. Al momento en que se generó este informe.",
	"scheduled_reports_tooltip_overdue_lessons": "Número total de lecciones que han pasado su fecha de vencimiento y aún no se han completado.",
	"scheduled_reports_tooltip_utilization": "Porcentaje de suscriptores activos que completaron al menos una lección durante este período de informe.",
	"common_completed": "Completado",
	"common_due": "Vence",
	"home_today_learning": "Aprendizaje del día",
	"home_enrolled_courses": "Cursos inscritos",
	"common_due_on": "Vence el",
	"today_learning_section_nothing_scheduled": "No tienes ningún aprendizaje asignado hoy.",
	"enrolled_courses_nothing_scheduled": "Aún no estás inscrito en ningún curso.",
	"common_announcement": "Anuncio",
	"announcement_content_video": "Video",
	"announcement_content_file": "Archivo",
	"course_lesson_sequence_warning_title": "¡Oye, ve más despacio!",
	"course_lesson_sequence_warning_message": "Las lecciones deben completarse en orden. La siguiente es {{lessonTitle}}.",
	"course_lesson_next_lesson": "la siguiente lección",
	"course_content_title": "Contenido del Curso",
	"rxd_next_lesson": "Siguiente Lección",
	"rxd_complete_lesson": "Completar Lección",
	"rxd_back_to_course": "Volver al Curso",
	"rxd_previous_lesson": "Lección Anterior",
	"rxd_error_completing_course_title": "Error al completar el curso",
	"rxd_error_completing_course_description": "Por favor inténtelo de nuevo o contacte con soporte técnico ",
	"rxd_course_not_found_error_title": "Curso no encontrado",
	"rxd_no_course_access_title": "Sin acceso al curso",
	"rxd_an_unexpected_error_occurred_title": "Se produjo un error inesperado",
	"lessons_completed": "LECCIONES COMPLETADAS",
	"rxd_complete_course": "Completar Curso",
	"rxd_complete_previous_lesson_first_title": "Complete primero la lección anterior",
	"rxd_complete_previous_lesson_first_description": "Esta lección no es accesible en el modo actual",
	"rxd_validating_access": "Validando accessos",
	"rxd_access_restricted": "Acceso Restringido",
	"show_less": "Mostrar Menos",
	"read_more": "Leer Mas",

	"admin_course_field_title": "Título",
	"admin_course_field_description": "Descripción",
	"admin_course_validation_field_max_length": "{{field}} no puede superar {{max}} caracteres.",
	"admin_course_char_count": "{{current}} / {{max}} caracteres",
	"admin_course_validation_fix_before_save": "Corrige los errores siguientes antes de guardar.",

	"admin_course_validation_title_required": "El título es obligatorio",
	"admin_course_validation_content_type_required": "El tipo de contenido es obligatorio",
	"admin_course_validation_work_category_job_training_required": "Se requiere al menos una categoría de trabajo para capacitación laboral",
	"admin_course_validation_job_category_job_training_required": "Se requiere al menos una categoría de puesto para capacitación laboral",
	"admin_course_validation_featured_image_required": "La imagen destacada es obligatoria",

	"admin_bulk_complete_lessons_success": "Se marcaron {{count}} lección(es) como completadas",
	"admin_bulk_complete_lessons_all_failed": "No se pudieron marcar las lecciones como completadas.",
	"admin_bulk_complete_lessons_partial": "Se marcaron {{completed}} lección(es) como completadas; {{failed}} fallaron.",
	"admin_bulk_complete_lessons_error": "No se pudieron marcar las lecciones como completadas: {{message}}",

	"lesson_completed_on": "Lección completada el {{date}}",
	"store_update_modal_title": "Nueva actualización disponible",
	"store_update_modal_subtitle": "¡Hemos hecho mejoras emocionantes en la app! Actualiza ahora para disfrutar de las últimas funciones.",
	"store_update_modal_update_now": "Actualizar ahora",
	"store_update_modal_maybe_later": "Quizás después",

	"leaderboard_card_position_hint": "Posición en la clasificación",
	"leaderboard_modal_month_ranking": "Clasificación de {{month}}",
	"leaderboard_modal_title_suffix": "en la tabla",
	"leaderboard_modal_col_rank": "Puesto",
	"leaderboard_modal_col_name": "Nombre",
	"leaderboard_modal_col_points": "Puntos",
	"leaderboard_modal_list_label": "Clasificación",
	"leaderboard_modal_list_empty": "Aún no hay clasificación para este período.",
	"leaderboard_modal_company_title": "Clasificación de la empresa",
	"leaderboard_modal_locating_user": "Buscando tu posición…",
	"leaderboard_modal_list_error": "No se pudo cargar la clasificación. Intenta cerrar y abrir de nuevo.",
	"admin_leaderboard_nav": "Tabla de posiciones",
	"admin_leaderboard_nav_aria": "Ir a la tabla de posiciones",
	"admin_leaderboard_page_title": "Tabla de posiciones",
	"admin_leaderboard_subtitle_prefix":
		"Realiza un seguimiento del progreso de los empleados mediante los puntos obtenidos en lecciones, cursos y cuestionarios.",
	"leaderboard_card_open_modal": "Ver tabla de posiciones",

	"leaderboard_points_guide_link": "Ver cómo calculamos cada punto",
	"leaderboard_points_guide_back": "Volver a la tabla",
	"leaderboard_points_guide_dialog_aria": "Cómo se calculan los puntos de la tabla",
	"leaderboard_points_guide_close": "Cerrar guía de puntos",
	"leaderboard_points_guide_col_event": "Evento",
	"leaderboard_points_guide_col_points": "Puntos",
	"leaderboard_points_guide_col_frequency": "Frecuencia",
	"leaderboard_points_guide_table_aria": "Desglose de puntos",
	"leaderboard_points_guide_list_empty": "Aún no hay eventos de puntos configurados.",
	"leaderboard_points_event_completed_lesson": "Lección completada",
	"leaderboard_points_event_quiz_perfect": "Cuestionario completado al 100%",
	"leaderboard_points_event_completed_course": "Curso completado",
	"leaderboard_points_px": "{{count}} PX",
	"leaderboard_points_frequency_recurring": "Recurrente",

	"points_earned_suffix": "PUNTOS",
	"footer_test_points_animation": "Probar +20 puntos"
};